import {
  FETCH_GAMA_SECTIONS_REQUEST,
  FETCH_GAMA_SECTIONS_SUCCESS,
  FETCH_GAMA_SECTIONS_ERROR,
  SAVE_GAMA_FORM_REQUEST,
  SAVE_GAMA_FORM_SUCCESS,
  SAVE_GAMA_FORM_ERROR,
  FETCH_ALL_GAMA_BY_YEAR_REQUEST,
  FETCH_ALL_GAMA_BY_YEAR_SUCCESS,
  FETCH_ALL_GAMA_BY_YEAR_ERROR,
  RESET_STATE_GAMA
} from 'actionTypes'

const DEFAULT_STATE = {
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
  save: {
    isUpdating: false,
    error: null,
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case RESET_STATE_GAMA:
      return DEFAULT_STATE
    case FETCH_GAMA_SECTIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      }

    case FETCH_GAMA_SECTIONS_SUCCESS:
      return {
        ...state,
        get: {
          ...state.get,
          record: action.payload,
          isFetching: false,
          error: null,
        },
      }

    case FETCH_GAMA_SECTIONS_ERROR:
      return {
        ...state,
        get: {
          ...state.get,
          record: {},
          isFetching: false,
          error: action.payload,
        },
      }

    case SAVE_GAMA_FORM_REQUEST:
      return {
        ...state,
        save: {
          ...state.save,
          isUpdating: true,
        },
      }

    case SAVE_GAMA_FORM_SUCCESS:
      return {
        ...state,
        save: {
          ...state.save,
          isUpdating: false,
          error: null,
        },
        get: {
          ...state.get,
          record: {
            ...state.get.record,
            ...action.payload,
          },
        },
      }

    case SAVE_GAMA_FORM_ERROR:
      return {
        ...state,
        save: {
          ...state.save,
          isUpdating: false,
          error: action.payload.error,
        },
      }

    case FETCH_ALL_GAMA_BY_YEAR_REQUEST:
      return {
        ...state,
        save: {
          ...state.save,
          isUpdating: true,
          error : null
        },
      }

      case FETCH_ALL_GAMA_BY_YEAR_SUCCESS:
        return {
          ...state,
          save: {
            ...state.save,
            isUpdating: false,
            error: null
          },

          get: {
            ...state.get,
            record: {
              ...state.get.payload,
              ...action.payload
            }
          },
        }

      case FETCH_ALL_GAMA_BY_YEAR_ERROR:
        return {
          ...state,
          save: {
            ...state.save,
            isUpdating: false,
            error: action.payload.error
          }
        }
    default:
      return state
  }
}

export default record
